module.exports = "<div id=\"updating\">\n  <div class=\"load-slides\">\n    <div class=\"slide\"></div>\n    <div class=\"slide\"></div>\n    <div class=\"slide\"></div>\n  </div>\n  <div class=\"load-spinner\">\n    <div class=\"spin-loader\"></div>\n    <p id=\"update-text\"></p>\n    <div class=\"progress-container\">\n      <div class=\"update-progress\"></div>\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./node_modules/extract-loader/lib/extractLoader.js!./node_modules/html-loader!./src/shared/childupp-auto-update/cordova-auto-update/ui/auto-update-ui.html
// module id = MTdW
// module chunks = 1